import React, {useEffect, useState, useCallback, useRef} from 'react';
import { connect } from "react-redux";
import { setSQFTAr3dPopup } from "../../../../../actions/sqftMenuFunctions";
import MultiLoader from "../../../../ui/multiLoader";
import { DEVICE_TYPE, getDeviceType } from "../../../helpers/sqftMobileHelper";
import ARButtonGoogleWebXR from "./ARButtonGoogleWebXR";
import SeparateModelGLBViewer from "../threeD/glbViewer/SeparateModelGLBViewer";
import SqftStore from "../../canvas/store/sqftStore";
import SceneExporter from "../threeD/glbViewer/scene/SceneExporter";
import ARViewUSDZButton from "./ARViewUSDZButton";
import {loadScriptPromise} from "../../../../../misc/loadScript";
import {ASYNC_SCRIPTS} from "../../../../../loadingLogic";

const ARWorkspaceSeparateModels = (props) => {
  const { cabinetsGlb, isMobile } = props;
  const [qrImage, setQrImage] = useState(null);
  const [glbLink, setGlbLink] = useState(null);
  const [usdzLink, setUsdzLink] = useState(null);
  const canvasRef = useRef(null);
  const lightIntensity = 20;

  useEffect(() => {
    const initializeViewer = async () => {

      await loadScriptPromise(ASYNC_SCRIPTS.three, "three");

      const viewGL = new SeparateModelGLBViewer(canvasRef.current, cabinetsGlb, lightIntensity, isMobile);
      await viewGL.modelsLoader.loadAllModels();
      SqftStore.viewGL = viewGL;

      const exporter = new SceneExporter(SqftStore.viewGL.scene);
      const deviceType = getDeviceType();

      const sceneFiles = await exporter.saveFiles(deviceType);
      const qrCode = await exporter.generateQRCode(sceneFiles);

      SqftStore.viewGL.closeMultiLoader();
      setQrImage(qrCode);

      const glbFile = sceneFiles.find((file) => file.url.endsWith(".glb"));
      const usdzFile = sceneFiles.find((file) => file.url.endsWith(".usdz"));
      setGlbLink(glbFile ? glbFile.url : null);
      setUsdzLink(usdzFile ? usdzFile.url : null);

      return () => {
        viewGL.dispose();
        SqftStore.viewGL = null;
      };
    };

    initializeViewer();
  }, [isMobile, cabinetsGlb]);

  const renderArButton = useCallback(() => {
    if (!glbLink) return null;
    const deviceType = getDeviceType();
    return deviceType === DEVICE_TYPE.Android ? (
      <ARButtonGoogleWebXR url={glbLink} />
    ) : (
      <ARViewUSDZButton url={usdzLink} />
    );
  }, [glbLink, usdzLink]);

  return (
    <div className="arDWorkspace">
      <div className="ar-d-workspace">
        <canvas className="threeDWorkspace-canvas hidden" ref={canvasRef} />
        { isMobile
          ? renderArButton()
          : qrImage
            ? <img src={qrImage} alt="QR Code" />
            : <MultiLoader useCabinetLoader={true} />
        }
      </div>
    </div>
  );
};

const mapStateToProps = ({ sqftState, serverState }) => ({
  cabinetsGlb: sqftState.cabinetsGlb,
  isMobile: serverState.isMobile,
});

const mapDispatchToProps = {
  setSQFTAr3dPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(ARWorkspaceSeparateModels);
